<template>
    <div class="m-userinfo">
        <p v-if="login_flag">
            您好，{{ info.nickName || info.uid }}
            <span v-if="info.areaId">【{{ queryArea(info.areaId) }}】</span>
            <!-- <span v-if="info.uid && info.areaId" @click="switch_area()">【切换大区】</span> -->
            <span v-if="!info.areaId" @click="$bind_modal()">【绑定大区】</span>
            <span class="u-btn logout" @click="call_logout">退出</span>
        </p>
        <p v-else>您好仙术师，请<span class="u-btn login" @click="call_login">登录</span></p>
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import mslogin from '@/assets/js/msLogin.js';

export default {
    data (){
        return {

        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    methods : {
        queryArea(num) {
            var area = '暂无大区信息';

            if (num == 1) {
                area = '火烧赤壁';
            } else if (num == 2) {
                area = '草船借箭';
            } else if (num == 6) {
                area = '荆州之战';
            } else if (num == 7) {
                area = '青梅煮酒';
            } else if (num == 8) {
                area = '官渡之战';
            } else if (num == 9) {
                area = '桃园结义';
            } else if (num == 11) {
                area = '九伐中原';
            } else if (num == 12) {
                area = '逐鹿中原';
            } else if (num == 13) {
                area = '三分天下';
            } else if (num == 16) {
                area = '怀旧服';
            }else if (num == 17) {
                area = '铜雀台';
            } else if (num == 18) {
                area = '凤仪亭';
            }else if (num == 19) {
                area = '火凤燎原';
            }else if (num == 20) {
                area = '卧龙出渊';
            }else if (num == 100 || num == 101) {
                area = '测试大区';
            }

            return area;
        },

        call_login(){
            mslogin.open();
        },

        call_logout(){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },
    },
}
</script>

<style scoped>
@media only screen and (min-width: 1281px){
    .m-userinfo{
        font-size: 20px;
    }
}

.m-userinfo{
    /* display: flex;
    width: 100%; */
    margin: 0 auto;
    text-align: center;
    color: #f6f4e6;
    /* font-size: 20px; */
    text-align: center;
    /* background-image: url(~@/assets/images/bg-user.png); */
}

.m-userinfo .u-btn{
    margin: 0 12px;
    text-decoration: underline;
}

.u-btn.logout,
.u-btn.login{
    color: #f6f4e6;
}
</style>


// WEBPACK FOOTER //
// src/components/userinfo.vue